// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { boba as _boba } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the boba chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 288
 * Chain Name: Boba Network
 * Default Block Explorer: https://bobascan.com
 * Default RPC URL: https://mainnet.boba.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { boba } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: boba,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const boba = createCommon({
	..._boba,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
